import { EventBus } from '@ac/library-utils/dist/communication/event-bus';

export const MobileAppEventBus = new EventBus();
